import {styled} from "@mui/material/styles"
import {FavouriteState} from "../../models/Favourites"

interface IFavouriteProps {
    $favState: string
    $shouldAnimate: boolean
    $gifPath: string
    $activePNGPath: string
    $inactivePNGPath: string
}

export const FavouritesIcon = styled("svg", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<IFavouriteProps>`
    && {
        /* transform:rotate added to prevent pixel snapping and rectify visible jump in animation*/
        /* https://stackoverflow.com/questions/22097660/is-there-a-way-i-can-force-chrome-to-do-subpixel-rendering-for-a-slow-translatio
https://johnresig.com/blog/sub-pixel-problems-in-css/ */
        transform: rotateZ(-0.0000000001deg);
        width: 100%;
        height: 100%;
        ${iconProps =>
            iconProps.$favState === FavouriteState.Inactive &&
            `

                @media all and (-ms-high-contrast: none) {
                    background-image: url(${iconProps.$inactivePNGPath}); 
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                }
        `}

        ${iconProps =>
            iconProps.$favState === FavouriteState.Loading &&
            `
            stroke-dasharray: 40;
            stroke-dashoffset: 80;
            stroke-linecap: round;
            animation: favourite-loading 0.8s linear infinite reverse;

            @keyframes favourite-loading {
                0% {
                    stroke-dashoffset: 80;
                }
                100% {
                    stroke-dashoffset: 160;
                }
            }

            @media all and (-ms-high-contrast: none) {
                background-image: url(${iconProps.$gifPath}); 
                background-repeat: no-repeat;
                background-size: 100% 100%;
            }
        `}

        ${iconProps =>
            iconProps.$favState === FavouriteState.Active &&
            iconProps.$shouldAnimate &&
            `
            animation: favourite-loaded 1s ease-in-out;
            
            @keyframes favourite-loaded {
                0% {
                    transform: scale(1);
                }
                50% {
                    transform: scale(1.25);
                }
                100% {
                    transform: scale(1);
                }
            }
            
        `}

        ${iconProps =>
            iconProps.$favState === FavouriteState.Active &&
            `
            @media all and (-ms-high-contrast: none) {
                background-image: url(${iconProps.$activePNGPath}); 
                background-repeat: no-repeat;
                background-size: 100% 100%;
            }
            
        `}
    }
`

interface FavouritesButtonProps {
    onClick?: () => void
    "data-testid"?: string
    "aria-label"?: string
    title?: string
    $noPadding?: boolean | null
}

export const FavouritesButton = styled("button", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<FavouritesButtonProps>`
    && {
        padding: ${({$noPadding}) => ($noPadding ? "0" : "0.5rem")};
        height: 100%;
        width: 100%;
        background: none;
        border: none;
        cursor: pointer;
    }
`
